// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container */
.order-tabs-wrap {
  padding: 16px;
}

.order-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  border: 1px solid #e9ecef;
  overflow: hidden;
}

/* Header */
.order-header {
  padding: 12px 16px;
  border-bottom: 1px solid #eef1f4;
  background: #fafbfc;
}

.order-tabbar {
  display: flex;
  gap: 8px;
}

.tab-btn {
  padding: 8px 12px;
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
  background: #fff;
  border: 1px solid #e5e7eb;
  color: #111827;
}

.tab-btn.active {
  background: #111827;
  color: #fff;
  border-color: #111827;
}

/* Body */
.order-body {
  padding: 16px;
}

.order-section {
  background: #fff;
  border: 1px solid #eef1f4;
  border-radius: 10px;
  padding: 12px;
  margin-bottom: 16px;
}

.order-label {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: #334155;
  margin-bottom: 8px;
}

.order-textarea {
  width: 100%;
  border-radius: 8px;
  border: 1px solid #dfe3e8;
  padding: 10px;
  font-size: 14px;
  resize: vertical;
}

.order-actions {
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
}

.btn-primary {
  padding: 8px 14px;
  border-radius: 8px;
  border: 1px solid #0f172a;
  background: #0f172a;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
}

/* Table */
.table-wrap {
  overflow-x: auto;
  border-radius: 8px;
  border: 1px solid #eef1f4;
}

.notes-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  font-size: 14px;
}

.notes-table th,
.notes-table td {
  padding: 10px;
  text-align: left;
  border-bottom: 1px solid #f0f0f0;
}

.notes-table th {
  background: #f9fafb;
  font-weight: 600;
}

.notes-table td.muted {
  text-align: center;
  color: #6b7280;
}

.notes-row.optimistic {
  opacity: 0.6;
}






.oc-btn.primary {
  background: #1f6feb;
  border-color: #1f6feb;
  color: #fff;
}

.oc-muted {
  opacity: 0.75;
  font-size: 13px;
}

.oc-progress-card {
  margin-top: 12px;
  padding: 12px;
  border: 1px solid rgba(0,0,0,0.08);
  border-radius: 10px;
  background: rgba(0,0,0,0.02);
}

.oc-progress-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
}

.oc-progress-track {
  width: 100%;
  height: 10px;
  border-radius: 999px;
  background: rgba(0,0,0,0.10);
  overflow: hidden;
}

.oc-progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #1f6feb, #2ea043);
  width: 0%;
  transition: width 180ms ease;
}

.oc-modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 18px;
  z-index: 9999;
}

.oc-modal {
  width: min(640px, 100%);
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 20px 60px rgba(0,0,0,0.30);
  overflow: hidden;
}

.oc-modal-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 14px;
  border-bottom: 1px solid rgba(0,0,0,0.08);
}

.oc-modal-body {
  padding: 14px;
}

.oc-modal-foot {
  display: flex;
  gap: 8px;
  align-items: center;
  padding: 12px 14px;
  border-top: 1px solid rgba(0,0,0,0.08);
}

.oc-modal-kpis {
  display: flex;
  gap: 10px;
  margin-top: 12px;
}

.oc-kpi {
  flex: 1 1;
  border: 1px solid rgba(0,0,0,0.08);
  border-radius: 10px;
  padding: 10px;
  background: rgba(0,0,0,0.02);
}

.oc-kpi .k {
  font-size: 22px;
  font-weight: 700;
}

.oc-kpi .l {
  font-size: 12px;
  opacity: 0.75;
}

.oc-alert {
  border-radius: 10px;
  padding: 10px 12px;
  border: 1px solid rgba(0,0,0,0.08);
}

.oc-alert.success {
  background: rgba(46,160,67,0.10);
  border-color: rgba(46,160,67,0.25);
}

.oc-alert.warn {
  background: rgba(245,158,11,0.12);
  border-color: rgba(245,158,11,0.28);
}

.oc-badge.red {
  background: rgba(248,81,73,0.15);
  color: #c72f2a;
  border: 1px solid rgba(248,81,73,0.25);
}

`, "",{"version":3,"sources":["webpack://./src/components/orders/css/OrderTabs.css"],"names":[],"mappings":"AAAA,cAAc;AACd;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA,SAAS;AACT;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA,UAAU;AACV;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;;;;;;AAOA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,kCAAkC;EAClC,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oDAAoD;EACpD,SAAS;EACT,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,kCAAkC;EAClC,mBAAmB;EACnB,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;EAChC,kCAAkC;AACpC;;AAEA;EACE,iCAAiC;EACjC,mCAAmC;AACrC;;AAEA;EACE,gCAAgC;EAChC,cAAc;EACd,sCAAsC;AACxC","sourcesContent":["/* Container */\n.order-tabs-wrap {\n  padding: 16px;\n}\n\n.order-card {\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);\n  border: 1px solid #e9ecef;\n  overflow: hidden;\n}\n\n/* Header */\n.order-header {\n  padding: 12px 16px;\n  border-bottom: 1px solid #eef1f4;\n  background: #fafbfc;\n}\n\n.order-tabbar {\n  display: flex;\n  gap: 8px;\n}\n\n.tab-btn {\n  padding: 8px 12px;\n  border-radius: 8px;\n  font-size: 14px;\n  cursor: pointer;\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  color: #111827;\n}\n\n.tab-btn.active {\n  background: #111827;\n  color: #fff;\n  border-color: #111827;\n}\n\n/* Body */\n.order-body {\n  padding: 16px;\n}\n\n.order-section {\n  background: #fff;\n  border: 1px solid #eef1f4;\n  border-radius: 10px;\n  padding: 12px;\n  margin-bottom: 16px;\n}\n\n.order-label {\n  display: block;\n  font-size: 13px;\n  font-weight: 600;\n  color: #334155;\n  margin-bottom: 8px;\n}\n\n.order-textarea {\n  width: 100%;\n  border-radius: 8px;\n  border: 1px solid #dfe3e8;\n  padding: 10px;\n  font-size: 14px;\n  resize: vertical;\n}\n\n.order-actions {\n  margin-top: 10px;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.btn-primary {\n  padding: 8px 14px;\n  border-radius: 8px;\n  border: 1px solid #0f172a;\n  background: #0f172a;\n  color: #fff;\n  font-size: 14px;\n  cursor: pointer;\n}\n\n/* Table */\n.table-wrap {\n  overflow-x: auto;\n  border-radius: 8px;\n  border: 1px solid #eef1f4;\n}\n\n.notes-table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  font-size: 14px;\n}\n\n.notes-table th,\n.notes-table td {\n  padding: 10px;\n  text-align: left;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.notes-table th {\n  background: #f9fafb;\n  font-weight: 600;\n}\n\n.notes-table td.muted {\n  text-align: center;\n  color: #6b7280;\n}\n\n.notes-row.optimistic {\n  opacity: 0.6;\n}\n\n\n\n\n\n\n.oc-btn.primary {\n  background: #1f6feb;\n  border-color: #1f6feb;\n  color: #fff;\n}\n\n.oc-muted {\n  opacity: 0.75;\n  font-size: 13px;\n}\n\n.oc-progress-card {\n  margin-top: 12px;\n  padding: 12px;\n  border: 1px solid rgba(0,0,0,0.08);\n  border-radius: 10px;\n  background: rgba(0,0,0,0.02);\n}\n\n.oc-progress-top {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 10px;\n}\n\n.oc-progress-track {\n  width: 100%;\n  height: 10px;\n  border-radius: 999px;\n  background: rgba(0,0,0,0.10);\n  overflow: hidden;\n}\n\n.oc-progress-fill {\n  height: 100%;\n  background: linear-gradient(90deg, #1f6feb, #2ea043);\n  width: 0%;\n  transition: width 180ms ease;\n}\n\n.oc-modal-backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(0,0,0,0.45);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 18px;\n  z-index: 9999;\n}\n\n.oc-modal {\n  width: min(640px, 100%);\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0 20px 60px rgba(0,0,0,0.30);\n  overflow: hidden;\n}\n\n.oc-modal-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 14px;\n  border-bottom: 1px solid rgba(0,0,0,0.08);\n}\n\n.oc-modal-body {\n  padding: 14px;\n}\n\n.oc-modal-foot {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  padding: 12px 14px;\n  border-top: 1px solid rgba(0,0,0,0.08);\n}\n\n.oc-modal-kpis {\n  display: flex;\n  gap: 10px;\n  margin-top: 12px;\n}\n\n.oc-kpi {\n  flex: 1;\n  border: 1px solid rgba(0,0,0,0.08);\n  border-radius: 10px;\n  padding: 10px;\n  background: rgba(0,0,0,0.02);\n}\n\n.oc-kpi .k {\n  font-size: 22px;\n  font-weight: 700;\n}\n\n.oc-kpi .l {\n  font-size: 12px;\n  opacity: 0.75;\n}\n\n.oc-alert {\n  border-radius: 10px;\n  padding: 10px 12px;\n  border: 1px solid rgba(0,0,0,0.08);\n}\n\n.oc-alert.success {\n  background: rgba(46,160,67,0.10);\n  border-color: rgba(46,160,67,0.25);\n}\n\n.oc-alert.warn {\n  background: rgba(245,158,11,0.12);\n  border-color: rgba(245,158,11,0.28);\n}\n\n.oc-badge.red {\n  background: rgba(248,81,73,0.15);\n  color: #c72f2a;\n  border: 1px solid rgba(248,81,73,0.25);\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
